import React from "react";
import * as T from "./types";
import * as S from "./styles";
import C from "@assets/themes/colors";
import ClickOutside from "@components/ClickOutside";
import Button from "@components/Button";
import Input from "@components/Input";

const EMPTY_MESSAGE = "The set name can not be empty";
const REPEATED_MESSAGE = "That set name already exists";

const SetsMenuScreen: React.FC<T.IProps> = (props) => {

  const [name, setName] = props.editNameState;
  const [tipLabel, setTipLabel] = React.useState<string>();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }

  const handleClickOutside = () => {
    props.handleClose();
  }

  const handleAction = () => {
    if (props.screenProps.action) {
      props.screenProps.action(name);
    } else {
      handleClickOutside();
    }
  }

  const updateTipLabel = () => {
    const filteredSetNames = props.setNames.filter(setName => {
      if (props.screenProps?.id === "edit") return setName !== props.currentName;
      else return true;
    });
    if (filteredSetNames.includes(name.trim())) setTipLabel(REPEATED_MESSAGE);
    else if (name === "") setTipLabel(EMPTY_MESSAGE);
    else setTipLabel(undefined);
  }

  React.useEffect(() => {
    if (props.screenProps?.id !== "delete") {
      updateTipLabel();
    }
  }, [name]);

  return(
    <S.Root>
      <ClickOutside
        onClickOutside={handleClickOutside}
      >
        <S.Box>
          <S.Top>
            <S.Title>
              {props.screenProps.title}
            </S.Title>
          </S.Top>
          <S.Content>
            <S.Description>
              {props.screenProps.description}
            </S.Description>
            {
              ["copy", "edit"].includes(props.screenProps.id ?? "") &&
              <>
                <S.InputTitle>
                  Name
                </S.InputTitle>
                <Input
                  id="set-name-input"
                  placeholder=""
                  value={name}
                  handleChange={handleInputChange}
                  disabled={false}
                  tipLabel={tipLabel}
                  tipLabelColor={C.RED}
                  style={S.InputContainer}
                  inputStyle={S.InputName}
                />
              </>
            }
          </S.Content>
          <S.ActionsContainer>
            <S.Actions>
              {
                props.screenProps?.action &&
                <Button
                  onClick={handleClickOutside}
                  label="CANCEL"
                  style={S.CancelButton}
                  labelStyle={S.LabelCancelButton}
                />
              }
              <Button
                onClick={handleAction}
                label={props.screenProps.actionTitle ?? ""}
                disabled={Boolean(tipLabel)}
                style={S.ConfirmButton}
              />
            </S.Actions>
          </S.ActionsContainer>
        </S.Box>
      </ClickOutside>
    </S.Root>
  );
}

export default SetsMenuScreen;